
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import { ShipTo } from '@/features/shipment/types';
import { getCountryNameFromCode } from '@/features/shipment/helpers/createShipment';

@Component
export default class AddressDetails extends Vue {
  @Prop({ required: true }) address!: ShipTo;

  private getCountryNameFromCode = getCountryNameFromCode;
}
